import React, { useState } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
import { callAPI, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import dayjs from "dayjs";

const LeadReport = () => {
  const [rows, setRows] = useState<any[]>([]);

  const LeadColumns: GridColDef[] = [
    { field: "customername", headerName: "Customer Name", flex: 1 },
    { field: "leadCount", headerName: "Lead Count", flex: 1 },
    { field: "qualified", headerName: "Qualified", flex: 1 },
    { field: "quotation", headerName: "Quotation", flex: 1 },
    { field: "estimate", headerName: "Estimate", flex: 1 },
    { field: "reportSubmitted", headerName: "Report Submitted", flex: 1 },
    { field: "paid", headerName: "Paid", flex: 1 },

  ];

  const handleApply = async (payload: any) => {
    try {
      const fromDate = dayjs(payload.fromDate).format("YYYY-MM-DD");
      const toDate = dayjs(payload.to).format("YYYY-MM-DD");

      const userId = localStorage.getItem(LoacalVariables.UserId);
      if (!userId) {
        alert("UserId not found. Please login again.");
        return;
      }

      console.log("Using userId:", userId);

      const query = `?fromdate=${fromDate}&to=${toDate}&userId=${userId}`;

      const response = await callAPI(
        `FinancialReport/Lead-Report${query}`,
        Method.GET
      );

      console.log("API Response:", response);

      // Map rows with unique id for DataGrid
      const reportArray = response?.data?.data || [];

      setRows(
        reportArray.map((row: any, index: number) => ({
          ...row,
          id: index + 1,
        }))
      );
    } catch (err) {
      console.log("Error fetching Sales Report", err);
    }
  };

  return (
    <ReportBaseTemplate
      title="Lead Report"
      columns={LeadColumns}
      rows={rows}
      onApply={handleApply}
    />
  );
};

export default LeadReport;
